exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-map-notification[data-v-50c8e4ac]{text-align:center;margin:1em}@media only screen and (min-width:47.94em){.page-map-notification[data-v-50c8e4ac]{padding:15px;max-width:255px;position:absolute;top:0;right:35px;z-index:2;background-color:#ededed}}.page-map-notification__text[data-v-50c8e4ac]{font-weight:700;opacity:.8}.page-map-notification__action[data-v-50c8e4ac]{margin-top:1em}.page-map-notification__small[data-v-50c8e4ac]{display:block;margin-top:1em;opacity:.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50c8e4ac","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/page/map/Notification.vue
// module id = 85727c3b49233b5a05e9
// module chunks = 0